/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeliverableFilesList_storageClasses$ref: FragmentReference;
declare export opaque type DeliverableFilesList_storageClasses$fragmentType: DeliverableFilesList_storageClasses$ref;
export type DeliverableFilesList_storageClasses = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: DeliverableFilesList_storageClasses$ref,
|};
export type DeliverableFilesList_storageClasses$data = DeliverableFilesList_storageClasses;
export type DeliverableFilesList_storageClasses$key = {
  +$data?: DeliverableFilesList_storageClasses$data,
  +$fragmentRefs: DeliverableFilesList_storageClasses$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DeliverableFilesList_storageClasses",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7a4dbca9de415be1e30b2bb37af63ca5';
module.exports = node;
